import { gql } from '@apollo/client'
import client from '../utils/client'
import { MutationHandlerResult } from '../utils/errors'

export type UpdateMenuStateArgs = {
	restaurantId: string
	menuVersion: number
	// ACTIVE = aktivieren, OUTDATED = offline nehmen.
	newState: 'ACTIVE' | 'OUTDATED'
	// Beim Aktivieren: als Preview online, ohne Vertrag und Prüfung.
	preview?: boolean
	// Beim Aktivieren eines Imports: Beyer Development hat ihn gegen die Speisekarte geprüft.
	importChecked?: boolean
}

const updateMenuState = async ({
	restaurantId,
	menuVersion,
	newState,
	preview,
	importChecked,
}: UpdateMenuStateArgs): Promise<MutationHandlerResult> => {
	try {
		const { data, errors } = await client.mutate({
			mutation: gql`
				mutation UpdateMenuState(
					$restaurantId: ID!
					$menuVersion: Int!
					$newState: Status!
					$preview: Boolean
					$importChecked: Boolean
				) {
					updateMenuState(
						restaurantId: $restaurantId
						menuVersion: $menuVersion
						newState: $newState
						preview: $preview
						importChecked: $importChecked
					) {
						success
					}
				}
			`,
			variables: { restaurantId, menuVersion, newState, preview, importChecked },
			refetchQueries: ['CurrentUser'],
		})

		if (errors) {
			return { success: false, errors }
		}

		return { success: Boolean(data?.updateMenuState?.success), errors: null }
	} catch (e) {
		if (e instanceof Error && 'networkError' in e && e.networkError) {
			return { success: false, errors: 'NETWORK_ERROR' }
		}
		throw e
	}
}

export default updateMenuState
